export default (variable: Record<string, any> | null | undefined) => {
  if (variable === null || variable === undefined) {
    return false;
  }
  return !!Object.keys(variable).length;
};
